export const CHALLENGE_DIRECTORY = 'linchpintest13challenge';

export const CHALLENGE_START_DATE = '2023-09-15T09:00:00';
export const CHALLENGE_END_DATE = '2023-09-30T20:00:00';
export const CHALLENGE_NAME = 'The Linchpin Test 13 Challenge';
export const CHALLENGE_EARNED = 22;